import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/fermentations/$group_id/planning")({
  component: PlanningLayout,
});

function PlanningLayout() {
  return <Outlet />;
}

